<div
  class="bd-search-results-tab"
  [style]="{ height: 'calc(100vh - 44px - ' + filtersHeight() + 'px)' }"
  *transloco="let t; scope: 'featureSearch'"
>
  <ng-template
    #panelHeader
    let-icon="icon"
    let-titleKey="titleKey"
    let-count="count"
    let-onSeeAll="onSeeAll"
    let-seeAllDataId="seeAllDataId"
    let-wideLeftPadding="wideLeftPadding"
  >
    <div
      class="flex items-center justify-between pb-3"
      [class.pl-2]="!wideLeftPadding"
      [class.pl-4]="wideLeftPadding"
    >
      <div class="flex items-center gap-2">
        <i [class]="icon" aria-hidden="true"></i>
        <span class="bd-label-regular">{{ t(titleKey) }}</span>
        <bd-badge
          [label]="count.toString()"
          [type]="'info'"
          [customIcon]="''"
        ></bd-badge>
      </div>
      @if (count > 0) {
        <p-button
          [attr.data-id]="seeAllDataId"
          [label]="t('featureSearch.allTab.seeAll')"
          [link]="true"
          styleClass="bd-no-capitalize"
          (onClick)="onSeeAll()"
        />
      }
    </div>
  </ng-template>

  <ng-template
    #panelEmpty
    let-textKey="textKey"
    let-dataId="dataId"
    let-fillHeight="fillHeight"
  >
    <div
      [attr.data-id]="dataId"
      class="flex flex-col items-center justify-center gap-2"
      [class.flex-1]="fillHeight"
      [class.py-16]="!fillHeight"
    >
      <i class="ui-cactus" aria-hidden="true"></i>
      <span class="bd-caption">{{ t(textKey) }}</span>
    </div>
  </ng-template>

  <div
    class="bd-scrollable-results flex flex-col gap-6 pt-6"
    data-id="all-search-results-scroll"
  >
    <div class="flex items-stretch gap-6">
      <section
        data-id="all-views-panel"
        class="flex min-w-0 flex-1 flex-col rounded-lg border py-5 px-4"
      >
        <ng-container
          [ngTemplateOutlet]="panelHeader"
          [ngTemplateOutletContext]="{
            icon: 'ui-view',
            titleKey: 'featureSearch.quickFilters.view',
            count: viewsCount(),
            onSeeAll: onSeeAllViews,
            seeAllDataId: 'all-views-see-all',
            wideLeftPadding: false,
          }"
        ></ng-container>
        @if (viewsLoading()) {
          <bd-item-grid-loading
            data-id="loading-all-views"
            [loadingItemsCount]="3"
            [size]="'small'"
          ></bd-item-grid-loading>
        } @else if (viewItems().length > 0) {
          <bd-item-grid
            data-id="all-views-grid"
            [items]="viewListItems()"
            [size]="'small'"
          ></bd-item-grid>
        } @else {
          <ng-container
            [ngTemplateOutlet]="panelEmpty"
            [ngTemplateOutletContext]="{
              textKey: 'featureSearch.allTab.noViewsFound',
              dataId: 'all-views-empty',
              fillHeight: true,
            }"
          ></ng-container>
        }
      </section>
      <section
        data-id="all-workspaces-panel"
        class="flex min-w-0 flex-1 flex-col rounded-lg border py-5 px-4"
      >
        <ng-container
          [ngTemplateOutlet]="panelHeader"
          [ngTemplateOutletContext]="{
            icon: 'ui-workspace',
            titleKey: 'featureSearch.quickFilters.workspace',
            count: workspacesCount(),
            onSeeAll: onSeeAllWorkspaces,
            seeAllDataId: 'all-workspaces-see-all',
            wideLeftPadding: false,
          }"
        ></ng-container>
        @if (workspacesLoading()) {
          <bd-item-grid-loading
            data-id="loading-all-workspaces"
            [loadingItemsCount]="3"
            [size]="'small'"
          ></bd-item-grid-loading>
        } @else if (workspaceItems().length > 0) {
          <bd-item-grid
            data-id="all-workspaces-grid"
            [items]="workspaceListItems()"
            [size]="'small'"
          ></bd-item-grid>
        } @else {
          <ng-container
            [ngTemplateOutlet]="panelEmpty"
            [ngTemplateOutletContext]="{
              textKey: 'featureSearch.allTab.noWorkspacesFound',
              dataId: 'all-workspaces-empty',
              fillHeight: true,
            }"
          ></ng-container>
        }
      </section>
    </div>
    <section
      data-id="all-objects-panel"
      class="rounded-lg border py-5 pl-2 pr-4"
    >
      <ng-container
        [ngTemplateOutlet]="panelHeader"
        [ngTemplateOutletContext]="{
          icon: 'ui-object',
          titleKey: 'featureSearch.quickFilters.object',
          count: objectsCount(),
          onSeeAll: onSeeAllObjects,
          seeAllDataId: 'all-objects-see-all',
          wideLeftPadding: true,
        }"
      ></ng-container>
      @if (objectsLoading()) {
        <bd-object-search-results-loading
          data-id="loading-all-objects"
        ></bd-object-search-results-loading>
      } @else if (objectResultItems().length > 0) {
        <div class="flex flex-col" data-id="all-objects-list">
          @if (objectResultsMode() === 'table') {
            <bd-object-search-results-table
              [items]="previewedObjectItems()"
              [columnCatalogue]="columnCatalogue()"
              [layout]="tableLayout"
              [selection]="tableSelection()"
              [manageWorkspaceAccess]="tableManageWorkspaceAccess()"
              (openSearchResultItem)="openSearchResultItem.emit($event)"
              (deleteSearchResultItem)="deleteSearchResultItem.emit($event)"
              (openContentDetails)="openContentDetails.emit($event)"
              (itemSelectionToggled)="objectItemSelectionToggled.emit($event)"
              (selectedItemsChange)="objectSelectedItemsChange.emit($event)"
            ></bd-object-search-results-table>
          } @else {
            @for (item of previewedObjectItems(); track item.id) {
              <bd-object-search-result-item
                [item]="item"
                [isSelectionMode]="objectSelectionMode()"
                [selectedItems]="selectedObjectItems()"
                [isActive]="item.id === activeItemId() && isDrawerOpen()"
                [manageWorkspaceActionDisabled]="
                  manageWorkspaceActionDisabled()
                "
                [manageWorkspaceNoAccessTooltip]="
                  manageWorkspaceNoAccessTooltip()
                "
                (openSearchResultItem)="openSearchResultItem.emit($event)"
                (deleteSearchResultItem)="deleteSearchResultItem.emit($event)"
                (openContentDetails)="openContentDetails.emit($event)"
                (itemSelectionToggled)="objectItemSelectionToggled.emit($event)"
                (selectedItemsChange)="objectSelectedItemsChange.emit($event)"
              ></bd-object-search-result-item>
            }
          }
        </div>
      } @else {
        <ng-container
          [ngTemplateOutlet]="panelEmpty"
          [ngTemplateOutletContext]="{
            textKey: 'featureSearch.allTab.noObjectsFound',
            dataId: 'all-objects-empty',
          }"
        ></ng-container>
      }
    </section>
  </div>
</div>
